module.exports = __webpack_public_path__ + "img/icon_punched-card3.9859e81d.svg";